
if($('#want_invoice').is(":checked"))
{
    $("#vat_id").removeAttr('disabled');
    $("#company_name").removeAttr('disabled');
}else{
    $("#vat_id").attr('disabled','disabled');
    $("#company_name").attr('disabled','disabled');
}

if($('#want_invoice').length) {
    $('#want_invoice').change(function (event){
        var checkbox = event.target;
        if(checkbox.checked)
        {
            $("#vat_id").removeAttr('disabled');
            $("#company_name").removeAttr('disabled');
        }else{
            $("#vat_id").attr('disabled','disabled');
            $("#company_name").attr('disabled','disabled');
        }
    });

    // $("#want_invoice").iButton({
    //     labelOn: $("#want_invoice").data('yes'),
    //     labelOff: $("#want_invoice").data('no'),
    //     change: function ($input){
    //         if($input.is(":checked"))
    //         {
    //             $("#vat_id").removeAttr('disabled');
    //             $("#company_name").removeAttr('disabled');
    //         }else{
    //             $("#vat_id").attr('disabled','disabled');
    //             $("#company_name").attr('disabled','disabled');
    //         }
    //     }
    // });
}

if($('#country_code').length) {
    $("#country_code").select2({
        allowClear: false
    });
}


if($('#postal_code').length) {
    $("#postal_code").inputmask("mask", {"mask": "99-999"});
}

// if($('#postal_code').length) {
//     $("#vat_id").inputmask("mask", {"mask": "PL9999999999"});
// }
